import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCarsPracticeTests = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "-4 -4 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6936 4.2002H4.89561C3.07528 4.2002 1.59961 5.67586 1.59961 7.49619V19.8962C1.59961 21.7165 3.07528 23.1922 4.89561 23.1922H15.8956C17.7159 23.1922 19.1916 21.7165 19.1916 19.8962V9.69794M13.6936 4.2002H14.0731C14.9472 4.2002 15.7856 4.54745 16.4037 5.16557L18.2262 6.98811C18.8444 7.60623 19.1916 8.44458 19.1916 9.31873V9.69794M13.6936 4.2002V7.29794C13.6936 8.62342 14.7681 9.69794 16.0936 9.69794H19.1916",
			stroke: "#8A94A6",
			strokeWidth: 1.68,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.64453 1.2002H15.4429H15.9087C16.9816 1.2002 18.0106 1.54745 18.7693 2.16557L21.0062 3.98811C21.7649 4.60623 22.1911 5.44458 22.1911 6.31873V6.69794V16.8962",
			stroke: "#8A94A6",
			strokeWidth: 1.68,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 6.83805,
			y1: 13.5643,
			x2: 13.9581,
			y2: 13.5643,
			stroke: "#8A94A6",
			strokeWidth: 1.68,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 6.83805,
			y1: 17.9569,
			x2: 10.6584,
			y2: 17.9569,
			stroke: "#8A94A6",
			strokeWidth: 1.68,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgCarsPracticeTests);
export { ForwardRef as ReactComponent };
